import { render, staticRenderFns } from "./ApplicatorTable.vue?vue&type=template&id=1f32880a&scoped=true"
import script from "./ApplicatorTable.vue?vue&type=script&lang=js"
export * from "./ApplicatorTable.vue?vue&type=script&lang=js"
import style0 from "./ApplicatorTable.vue?vue&type=style&index=0&id=1f32880a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32880a",
  null
  
)

export default component.exports